import {
  UpgradeStatus,
  useGetCompany,
  useGetCompanySettings,
} from "@/api/companies";
import { computed } from "vue";
import { useAuth } from "../auth";
import { useRoute } from "vue-router";

export const useSupgrade = () => {
  const { data } = useGetCompany();
  const { data: companySettings } = useGetCompanySettings();
  const authStore = useAuth();
  const route = useRoute();

  const isSupgradable = computed(
    () => data.value?.upgrade.status === UpgradeStatus.Synced
  );

  const isScheduled = computed(
    () => data.value?.upgrade.status === UpgradeStatus.Scheduled
  );

  const showUpgradeBanner = computed(
    () =>
      isSupgradable.value &&
      authStore.isCompanyAdmin.value &&
      route.name !== "schedule-upgrade"
  );

  const showConfirmBanner = computed(
    () => isScheduled.value && route.name !== "schedule-confirmed"
  );

  const supgradeComplete = computed(
    () => data.value?.upgrade.status === UpgradeStatus.Completed
  );

  const isUpgrader = computed(() => {
    return (
      companySettings.value?.upgrade.scheduledBy ===
      authStore.authUser.value?.pk
    );
  });
  return {
    showUpgradeBanner,
    showConfirmBanner,
    supgradeComplete,
    isUpgrader,
  };
};
